import { Translation } from 'hooks/useTranslation/useTranslation';
import { useMemo } from 'react';
import { useSearch } from 'v2/hooks/useSearch/useSearch';
import { AccessCardEntry, CardStatus } from './cardFilterTypes';

const searchKeys = ['uuid', 'visitorName', 'visitorEmail', 'cardStatus'];

const cardStatusLabels: Record<CardStatus, keyof Translation> = {
  cardBlocked: 'card_blocked',
  userDeleted: 'user_deleted',
  cardExpired: 'card_expired',
  accessRightsChanged: 'access_rights_changed',
  userExpiresSoon: 'user_expires_soon',
  cardExpiresSoon: 'card_expires_soon'
};

const getCardStatusLabels = (statuses: CardStatus[], translation: Translation): string[] =>
  statuses.map((status) => translation[cardStatusLabels[status]]);

export const useAccessCardSearch = ({
  entries,
  search,
  translation
}: {
  entries: AccessCardEntry[];
  search: string;
  translation: Translation;
}): AccessCardEntry[] => {
  const searchableEntries = useMemo(
    () =>
      entries.map((entry) => ({
        ...entry,
        cardStatus: getCardStatusLabels(entry.statuses, translation)
      })),
    [entries, translation]
  );

  const matchedSearchable = useSearch({ data: searchableEntries, search, keys: searchKeys });

  return useMemo(() => matchedSearchable.map(({ cardStatus, ...entry }) => entry), [matchedSearchable]);
};
